<template>
    <div class="d-flex align-items-center text-primary">
        <a-icon icon="Calendar" />

        <div class="newspaper-preview__date-wrapper">
            obowiązuje od
            <strong v-text="material.public_from" />

            <span class="text-nowrap">
                do
                <strong v-text="material.public_to" />
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewspaperDate',

    props: {
        material: {
            type: Object,
            required: true
        }
    }
}
</script>
